// Non-grouped Permissions, if more Permissions exist for a particular group (or prefix), please create a new file; see: habitat.ts
export default {
    Checkout: { Plans: 'checkout:plans' },
    Camera: { Block: 'camera:block' },
    Profile: { Edit: 'profile:edit' },
    Signup: { View: 'signup:view' },
    Login: { View: 'login:view' },
    Subscription: { Edit: 'subscription:edit' },
    Redirect: { View: 'redirect:view' },
    Welcome: { View: 'welcome:view' },
    Favorite: { Edit: 'favorite:edit' },
    MyAlbum: { View: 'my-album:view' },
    EmailVerifyInput: { View: 'emailVerifyInput:view' },
    FreemiumOnboarding: { View: 'freemiumOnboarding:view' },
    Redeem: { View: 'redeem:view' },
    Media: { Download: 'media:download' },
};
